import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useUserAccounts } from "@trader-dashboard/shared";
import { ImportOrdersDialog } from './components';
import { OrdersTable } from './components/OrdersTable';
import { useOrders, Order } from '@/context/OrdersContext';
import { isDemoAccount, getDemoOrders } from '@/data/demoAccountHelper';

export const OrdersPage = (): React.ReactNode => {
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const { accountId } = useParams();

  const { selectedAccountId } = useUserAccounts();
  const { orders: realOrders, loading: realLoading, error: realError, hasMore: realHasMore, loadOrders, loadMore, refreshOrders } = useOrders();

  const isDemo = isDemoAccount(accountId);
  const orders = isDemo ? getDemoOrders() as Order[] : realOrders;
  const loading = isDemo ? false : realLoading;
  const error = isDemo ? undefined : realError;
  const hasMore = isDemo ? false : realHasMore;

  // Load initial orders when account changes
  useEffect(() => {
    if (isDemo) return;
    loadOrders();
  }, [selectedAccountId, loadOrders, isDemo]);

  if (error) {
    return (
      <div className="p-8 text-center">
        <div className="text-red-600 mb-4">Error: {error}</div>
        <button
          onClick={() => loadOrders()}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      <OrdersTable
        orders={orders}
        loading={loading}
        hasMore={hasMore}
        onLoadMore={loadMore}
        onImportClick={() => setImportDialogOpen(true)}
      />

      {selectedAccountId && (
        <ImportOrdersDialog
          open={importDialogOpen}
          onOpenChange={setImportDialogOpen}
          accountId={selectedAccountId}
          onImportComplete={refreshOrders}
        />
      )}
    </>
  );
};
